import { Dispatch } from "react";

import { TenderNoticePublicationType } from "@type/procurements/createProcurement/tenderNoticePublication";

import { TenderNoticePublicationStateAction } from "@reducers/types/procurements/create-procurements/tender-notice-publication-state";
import { CREATE_TENDER_NOTICE_PUBLICATION, GET_SINGLE_TNP } from "./types";
import api from "@helpers/api";

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_BASE_URL}${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE}/api/${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_VERSION}/${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_TYPE}/procurements`;

export const createTenderNoticePublication =
  (
    data: TenderNoticePublicationType,
    id: string | number,
    tenderNoticePublicationId: string | number,
  ) =>
  async (dispatch: Dispatch<TenderNoticePublicationStateAction>) => {
    const action = tenderNoticePublicationId ? "put" : "post";

    const postUrl = `${apiEndPoint}/${id}/tender-notice`;
    const putUrl = `${apiEndPoint}/${id}/tender-notice/${tenderNoticePublicationId}`;

    const url = tenderNoticePublicationId ? putUrl : postUrl;

    dispatch({ type: CREATE_TENDER_NOTICE_PUBLICATION.LOADING, payload: true });

    try {
      const res = await api[action](url, {
        ...data,
      });

      const resData = res.data || {};

      dispatch({
        type: CREATE_TENDER_NOTICE_PUBLICATION.SUCCESS,
        payload: {
          data: resData,
        },
      });
    } catch (err) {
      dispatch({ type: CREATE_TENDER_NOTICE_PUBLICATION.ERROR, payload: err });
    }
  };

export const fetchTNPDetails =
  (id: string | number) =>
  async (dispatch: Dispatch<TenderNoticePublicationStateAction>) => {
    dispatch({ type: GET_SINGLE_TNP.LOADING, payload: true });

    try {
      const res = await api.get(`${apiEndPoint}/${id}/tender-notice`);
      const data = res.data || {};

      dispatch({
        type: GET_SINGLE_TNP.SUCCESS,
        payload: {
          data,
        },
      });
    } catch (err) {
      dispatch({ type: GET_SINGLE_TNP.ERROR, payload: err });
    }
  };
